import { createSlice,PayloadAction } from '@reduxjs/toolkit';
import { TnCPolicyService } from '../lib/api/T&CnPolicy';
import { TnCPolicyDataType } from '../types/T&CnPolicy';
import { AppDispatch } from './index';

type CountryDataType = {
    countryName: string;
    ipAddress: string;
    countryCode?: string;
};

type InitialStateType = {
    loading: boolean;
    docUri: TnCPolicyDataType | null;
    countryData: CountryDataType | null;
};

const initialState: InitialStateType = {
    loading: true,
    docUri: null,
    countryData: null,
};

const policySlice = createSlice({
    name: 'policy',
    initialState,
    reducers: {
        setLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },
        setCountryName(state, action: PayloadAction<CountryDataType>) {
            state.countryData = action.payload;
        },
        setDocUri(state, action: PayloadAction<TnCPolicyDataType>) {
            state.docUri = action.payload;
        },
    },
});

export function getCountryDetailsByIPAddress() {
    return async (dispatch: AppDispatch) => {
        try {
            dispatch(policySlice.actions.setLoading(true));
            var request = new XMLHttpRequest();
            request.open('GET', 'https://free.freeipapi.com/api/json');
            request.setRequestHeader('Accept', 'application/json');

            request.onreadystatechange = function () {
                if (this.readyState === 4) {
                    const responseData = JSON.parse(this.responseText);
                    if (responseData?.countryName) {
                        dispatch(
                            policySlice.actions.setCountryName({
                                countryName: responseData?.countryName,
                                ipAddress: responseData?.ipAddress,
                                countryCode: responseData?.countryCode,
                            })
                        );
                    }
                }
            };

            request.send();
        } catch (error) {
            dispatch(policySlice.actions.setLoading(false));
        } finally {
            dispatch(policySlice.actions.setLoading(false));
        }
    };
}

export const getPolicyDoc = (countryData: CountryDataType) => {
    return async (dispatch: AppDispatch) => {
        try {
            dispatch(policySlice.actions.setLoading(true));

            const {
                resultObject: { privacyPolicy, termsAndConditions },
            } = await TnCPolicyService.getPublicPolicyDocument({
                countryName: countryData.countryName,
                countryCode: countryData.countryCode,
            });

            // if (privacyPolicy && termsAndConditions) {
            dispatch(policySlice.actions.setDocUri({ privacyPolicy, termsAndConditions }));
            // }
        } catch (err) {
            dispatch(policySlice.actions.setLoading(false));
        } finally {
            dispatch(policySlice.actions.setLoading(false));
        }
    };
};

export default policySlice.reducer;
export const { setLoading } = policySlice.actions;
